import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { Image } from 'foundations-components/transitional/components/Image';
import { EcosystemSlider } from 'trellis-ecosystem';
import { GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY as PUBLIC_GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontPublicRpc.dfc.new';
import { GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc.dfc.new';
import { CollectionCard } from '../../collections/components/CollectionCard';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { isQa } from '../../utils/env';
import { SUGGESTED_ACCREDITATIONS, SUGGESTED_ACCREDITATIONS_QA } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export function SuggestedAccreditations() {
  var _batchFilterOptionsRe, _batchFilterOptionsRe2;
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const batchFilterOptionsResult = useAppContextQuery({
    app: GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY,
    public: PUBLIC_GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY,
    options: {
      variables: {
        filters: {
          PROFILE_ACCREDITATIONS: isQa() ? SUGGESTED_ACCREDITATIONS_QA : SUGGESTED_ACCREDITATIONS
        },
        language: getLang(),
        includeHelpText: true
      }
    }
  });
  const trackCollectionCardClicked = (filter, index) => {
    var _filter$text;
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'filter card clicked',
      category: (_filter$text = filter.text) !== null && _filter$text !== void 0 ? _filter$text : '',
      itemIndex: index,
      subscreen: Subscreens.SUGGESTED_ACCREDITATIONS
    }));
  };
  const trackSliderButtonClicked = direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggested filter section ${direction} arrow clicked`,
      // Hardcoded index based on figma design layout
      itemIndex: 2,
      subscreen: Subscreens.SUGGESTED_ACCREDITATIONS
    }));
  };
  const accreditations = (_batchFilterOptionsRe = (_batchFilterOptionsRe2 = batchFilterOptionsResult.data) === null || _batchFilterOptionsRe2 === void 0 ? void 0 : _batchFilterOptionsRe2.result.filterOptions['PROFILE_ACCREDITATIONS']) !== null && _batchFilterOptionsRe !== void 0 ? _batchFilterOptionsRe : [];
  if (!accreditations.length) return null;
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "suggested-accreditations-section",
    marginBlockEnd: "1000",
    maxInlineSize: "100%",
    children: /*#__PURE__*/_jsx(EcosystemSlider, {
      cardWidth: 625,
      gradientColor: "fill-surface-recessed",
      onScrollButtonClick: trackSliderButtonClicked
      // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
      ,
      scrollButtonTop: "43.5%",
      title: unescapedText('marketplaceStorefront.suggestedFilters.title'),
      description: unescapedText('marketplaceStorefront.suggestedFilters.description'),
      children: accreditations.map((accreditation, index) => {
        var _accreditation$helpTe;
        return /*#__PURE__*/_jsx(CollectionCard, {
          buttonText: unescapedText('marketplaceStorefront.suggestedFilters.buttonText', {
            accreditation: accreditation.text
          }),
          description: (_accreditation$helpTe = accreditation.helpText) !== null && _accreditation$helpTe !== void 0 ? _accreditation$helpTe : '',
          href: `${Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS}?eco_PROFILE_ACCREDITATIONS=${accreditation.value}`,
          illustration: accreditation.icon ? /*#__PURE__*/_jsx(Image, {
            alt: "",
            inlineSize: "125px",
            responsive: false,
            src: accreditation.icon
          }) : undefined,
          name: accreditation.text,
          onClick: () => {
            trackCollectionCardClicked(accreditation, index);
            scrollToTop();
          },
          slug: accreditation.value
        }, accreditation.value);
      })
    })
  });
}